import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { numberFormatter } from '../../../../utils/number';

const PettyCash = ({
  totalPettyCash,
}) => {
  if (totalPettyCash <= 0) {
    return null;
  }

  return (
    <>
      <hr />
      <h2>Fondo fijo</h2>
      <Row>
        <Col>
          <ResourceProperty label="Total de fondo fijo: ">
            {numberFormatter({ value: totalPettyCash })}
          </ResourceProperty>
        </Col>
      </Row>
    </>
  );
};

PettyCash.propTypes = {
  totalPettyCash: PropTypes.number.isRequired,
};

export default PettyCash;
